module.exports = __webpack_public_path__ + "static/img/Myanmar_apr_2017_carousel_v2.5554a7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Myanmar_apr_2017_carousel_v2.jpg
// module id = 248
// module chunks = 1